module.exports = __webpack_public_path__ + "img/second.914568fd.png";